import React from "react";
import RailTransport from "./RailTransport";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import Scope3Layout from "../../../../Layout/Scope3Layout";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../../../Layout/GroupAdminSidebar";
import { useUser } from "../../../../context/AuthContext";
const Rail = () => {
   const{user}=useUser();
  return (
    <MainDashboardLayout sidebar={user?.groupManager?<GroupAdminSidebar/>:<Scope3Layout />}>
      <Unauthorized requiredModule="Environment | Scope 3 | Transportation">
        <RailTransport />
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Rail;
